import AbstractChatMessage from './AbstractChatMessage'
import { MessageTypes } from '@/constants/chat/MessageTypes'

export default class VacancyArchivedChatMessage extends AbstractChatMessage {
  constructor(data: LX.VacancyArchivedChatMessage) {
    super(data)
    this.body = 'This Full-time Job was closed by the customer.'
  }

  static fromServer(data: LX.VacancyArchivedChatMessage) {
    return new VacancyArchivedChatMessage(data)
  }
}
